module.exports = __webpack_public_path__ + "img/icon_clock.eb7d926d.svg";